import type StaticMapSize from '@alltrails/types/StaticMapSize';
import { X_AT_KEY } from './api';

export type Size = StaticMapSize | '1280x480' | '295x240';

type SharedArgs = {
  baseUrl: string;
  id: string | number;
  includePois?: boolean;
  scale: number;
  size: Size;
};

type MapsArgs = SharedArgs & {
  type: 'maps';
};

type TrailsArgs = SharedArgs & {
  show3d?: boolean;
  style?: 'alltrails' | 'satellite';
  type: 'trails';
};

const getStaticMapUrl = (args: MapsArgs | TrailsArgs) => {
  const { baseUrl, id, scale, size, type } = args;

  const params = new URLSearchParams();
  params.set('key', X_AT_KEY);
  params.set('size', size);
  params.set('scale', String(scale));

  if (type === 'trails') {
    const { includePois, show3d, style } = args;

    if (includePois) {
      params.set('pois', 'true');
    }

    if (show3d) {
      params.set('show_3d', 'yes');
    }

    if (style) {
      params.set('style', style);
    }
  }

  return `${baseUrl}/api/alltrails/v3/${type}/${id}/static_map?${params.toString()}`;
};

export default getStaticMapUrl;
